import { FilterLogic, TransactionRuleCriteria } from '@types'

export const CONTROL_SIZE = 'sm'

const DEFAULT_CRITERIA_MODEL = {
  logic: FilterLogic.AND,
  params: [],
} satisfies TransactionRuleCriteria

export const getDefaultCriteriaModel = (): TransactionRuleCriteria => ({
  logic: DEFAULT_CRITERIA_MODEL.logic,
  params: [],
})
